module.exports = __webpack_public_path__ + "media/images/xc_1-0a9f1d00e44dea5721b8f1017c302e30.png";